import React from 'react';
import discountImgMobile from '../../../images/lp/promo/Promo_Mobile.webp';
import discountImgTablet from '../../../images/lp/promo/Promo_Tablet.webp';
import discountImgDesktop from '../../../images/lp/promo/Promo_Desktop.webp';
import { PROMO_ALT_TEXT } from '../../../utils/lpPromoConfig';

interface DiscountModuleProps {
    linkTo?: string;
}

export function DiscountModule({ linkTo = '#googlelp-quote' }: DiscountModuleProps) {
    return (
        <section className="googlelp-discount-module googlelp-container mx-auto">
            <a href={linkTo} className="googlelp-discount-link">
                <picture className="d-block">
                    <source media="(min-width: 1200px)" srcSet={discountImgDesktop} />
                    <source media="(min-width: 768px)" srcSet={discountImgTablet} />
                    <img
                        src={discountImgMobile}
                        alt={PROMO_ALT_TEXT}
                        className="d-block w-100 rounded-xl max-w-full mx-auto"
                    />
                </picture>
            </a>
        </section>
    );
}

export default DiscountModule;
